<template>
    <div>
        <b-overlay :show="confirm" no-wrap @shown="onShown">
            <template #overlay>
                <div v-if="processing" class="d-flex align-items-center">
                    <strong>Removing...</strong>
                    <b-spinner class="ml-auto"></b-spinner>
                </div>
                <div v-else ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
                    <p class="text-center">
                        <i class="fa-light fa-xmark text-danger"></i> <strong class="text-danger">DELETE DIAGNOSTIC REFERRAL DOCUMENT {{ filename }} </strong>
                    </p>
                    <div class="text-center">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
                        <b-button variant="outline-success" @click="onConfirmed">Confirm</b-button>
                    </div>
                </div>
            </template>
        </b-overlay>
        <b-form-group>
            <template v-if="filename">
                <b-input-group prepend="Result Document">
                    <b-input-group-prepend>
                        <b-button variant="primary" @click="openDocument"><i class="fa-solid fa-eye"></i></b-button>
                    </b-input-group-prepend>
                    <b-form-input readonly v-model="filename" />
                    <b-input-group-append>
                        <b-button variant="danger" @click="onRemoveDocument"><i class="fa-solid fa-xmark"></i></b-button>
                    </b-input-group-append>
                </b-input-group>
            </template>
            <template v-else>
                <b-form-file ref="fileUpload" placeholder="Upload Result Document" @input="onFileChange" :accept="formats" />
            </template>
        </b-form-group>
        <b-form-group v-if="$store.getters['loading/isLoading'](`document_${referral?.id}`)">
            <b-progress height="20px" show-progress animated>
                <b-progress-bar :value="100" variant="success">
                    <span>Uploading...</strong></span>
                </b-progress-bar>
            </b-progress>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
export default {
    props: {
        referral: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            formats: ".jpeg, .jpg, .png, .pdf, .xls, .doc, .xlsx, .docx",
            confirm: false,
            processing: false
        }
    },
    computed: {
        filename() {
            return this.referral ? this.referral?.filename : null
        }
    },
    methods: {
        ...mapActions('lab', ['uploadLabDocument', 'deleteLabDocument']),
        async onFileChange(file) {
            const form = Form.create()
                .withData({
                    document: file,
                    consistency_token: this.referral?.consistency_token
                })

                await this.uploadLabDocument({id: this.referral?.id, data: form.formData()})
        },
        openDocument() {            
            if (['.jpg', '.jpeg', '.png'].includes(this.referral?.document_extension)) {
                this.$viewerApi({
                  images: [this.referral?.document_url],
                })
            }else{
                window.open(this.referral?.document_url, '_blank')
            }

        },
        onRemoveDocument() {
            this.confirm = true
            this.processing = false
        },
        onConfirmed() {
            this.processing = true
            this.deleteLabDocument(this.referral?.id).then(() => {
                this.confirm = false
                this.processing = false

            })
            .catch(errors => {
                this.confirm = false
                this.processing = false
            })
        },
        onShown() {
            // Focus the dialog prompt
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
            this.processing = false
        }
    }
}
</script>